/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Coverage_IntroInputs */

const ja_playdata_about_coverage_intro = /** @type {(inputs: Playdata_About_Coverage_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATAが独自に取得したストリーミング配信のデータに基づいています。対象となる大会・イベントの種類は下記となります。`)
};

const en_playdata_about_coverage_intro = /** @type {(inputs: Playdata_About_Coverage_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA reports are based on streaming data obtained independently. The following types of tournaments and events are covered:`)
};

/**
* | output |
* | --- |
* | "PLAYDATA reports are based on streaming data obtained independently. The following types of tournaments and events are covered:" |
*
* @param {Playdata_About_Coverage_IntroInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_about_coverage_intro = /** @type {((inputs?: Playdata_About_Coverage_IntroInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Coverage_IntroInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_coverage_intro(inputs)
	return en_playdata_about_coverage_intro(inputs)
});